module.exports = __webpack_public_path__ + "static/img/t43.4f8b6815.png";